import React from 'react';
import CrudPage from '../../components/CrudPage';
import { addressesApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'addressId' },
  { header: 'Street Address', field: 'streetAddress' },
  { header: 'City', field: 'city' },
  { header: 'State', field: 'state' },
  { header: 'Postal Code', field: 'postalCode' },
  { header: 'Country ID', field: 'countryId' },
];

const formFields = [
  { name: 'streetAddress', label: 'Street Address', type: 'text', required: true },
  { name: 'streetNumber', label: 'Street Number', type: 'number' },
  { name: 'buildingNumber', label: 'Building Number', type: 'text' },
  { name: 'appartNumber', label: 'Apartment Number', type: 'number' },
  { name: 'city', label: 'City', type: 'text', required: true },
  { name: 'state', label: 'State', type: 'text' },
  { name: 'postalCode', label: 'Postal Code', type: 'text' },
  { name: 'countryId', label: 'Country ID', type: 'number' },
  { name: 'latitude', label: 'Latitude', type: 'number', step: '0.00000001' },
  { name: 'longitude', label: 'Longitude', type: 'number', step: '0.00000001' },
];

const AddressesPage = () => (
  <CrudPage
    title="Addresses"
    subtitle="Manage property addresses"
    api={addressesApi}
    columns={columns}
    formFields={formFields}
    idField="addressId"
    searchField="streetAddress"
  />
);

export default AddressesPage;
